<div class="app-modal-spinner">
  <header class="edit-header"><h1>記録を選択</h1></header>
  <div class="container">
    <h2>種類を選択</h2>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="form">
      <ul class="panel-list">
        <li *ngFor="let titleSet of titleSetList; index as i">
          <app-record-select-item
            [titleSet]="titleSet"
            [form]="getForm(i)"
          ></app-record-select-item>
        </li>
      </ul>
      <app-modal-footer
        excuteText="選択"
        [disabled]="form.invalid"
        (onCloseChange)="onCloseChange.emit()"
      ></app-modal-footer>
    </form>
  </div>
</div>
